var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"}},[_c('path',{attrs:{"d":"M18 6.65332L6 18.6533M18 18.6533L6 6.65332","stroke":_vm.color || '#8B8B8B',"stroke-width":"1.5","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }